<template>
  <div class="home-quick-actions">
    <el-card shadow="never" class="home-quick-actions__card" @click.native="go('/servicos/prepostagem/adicionar')">
      <i class="el-icon-circle-plus-outline home-quick-actions__icon"></i>
      <div>
        <div class="home-quick-actions__title">{{ $t("criar-prepostagem") }}</div>
        <div class="home-quick-actions__desc">{{ $t("criar-prepostagem-desc") }}</div>
      </div>
    </el-card>

    <el-card shadow="never" class="home-quick-actions__card" @click.native="go('/servicos/importar/upload')">
      <i class="el-icon-upload2 home-quick-actions__icon"></i>
      <div>
        <div class="home-quick-actions__title">{{ $t("importacao-massa") }}</div>
        <div class="home-quick-actions__desc">{{ $t("importacao-massa-desc") }}</div>
      </div>
    </el-card>

    <el-card
      v-if="hasPdv"
      shadow="never"
      class="home-quick-actions__card"
      @click.native="go('/servicos/pdv')"
    >
      <i class="el-icon-shopping-cart-2 home-quick-actions__icon"></i>
      <div>
        <div class="home-quick-actions__title">{{ $t("pdv") }}</div>
        <div class="home-quick-actions__desc">{{ $t("abrir-pdv-desc") }}</div>
      </div>
    </el-card>

    <el-card shadow="never" class="home-quick-actions__card home-quick-actions__card--track">
      <i class="el-icon-location-outline home-quick-actions__icon"></i>
      <div class="home-quick-actions__track">
        <div class="home-quick-actions__title">{{ $t("rastrear-objeto") }}</div>
        <el-input
          v-model="tag"
          size="small"
          :placeholder="$t('digite-etiqueta')"
          clearable
          @keyup.enter.native="track"
        >
          <el-button slot="append" icon="el-icon-search" @click="track" />
        </el-input>
      </div>
    </el-card>

    <PrepostEdit
      v-if="trackOpen"
      :tag="trackTag"
      :dialog="trackOpen"
      state="VIEW"
      tab="tracking"
      v-on:close="trackOpen = false"
    />
  </div>
</template>

<script>
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";

export default {
  name: "HomeQuickActions",
  components: { PrepostEdit },
  props: {
    hasPdv: { type: Boolean, default: false },
  },
  data() {
    return {
      tag: "",
      trackTag: "",
      trackOpen: false,
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    track() {
      const tag = this.tag.trim().toUpperCase();
      if (!tag) {
        this.$router.push({ name: "objects.sro" });
        return;
      }
      this.trackOpen = false;
      this.trackTag = tag;
      this.$nextTick(() => {
        this.trackOpen = true;
      });
    },
  },
};
</script>

<style>
.home-quick-actions {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.home-quick-actions__card {
  flex: 1 1 240px;
  margin: 0 10px 10px 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.home-quick-actions__card:not(.home-quick-actions__card--track):hover {
  background-color: var(--me-fill);
}

.home-quick-actions__card .el-card__body {
  display: flex;
  align-items: center;
}

.home-quick-actions__card--track {
  cursor: default;
}

.home-quick-actions__icon {
  font-size: 32px;
  color: var(--me-primary);
  margin-right: 14px;
  transition: color 0.15s ease;
}

.home-quick-actions__card:not(.home-quick-actions__card--track):hover .home-quick-actions__icon {
  color: #f6921e;
}

.home-quick-actions__title {
  font-weight: 600;
  color: var(--me-text-primary);
  margin-bottom: 2px;
}

.home-quick-actions__desc {
  font-size: 12px;
  color: var(--me-text-secondary);
}

.home-quick-actions__track {
  flex: 1;
}
</style>
